import { Component, Input } from '@angular/core';

export interface SectionSocialCardData {
  title: string;
  description: string;
  image: string;
}

export interface SectionSocialData {
  title: string;
  cards: Array<SectionSocialCardData>;
}

@Component({
  selector: 'fcp-section-social',
  templateUrl: './section-social.component.html',
  styleUrls: ['./section-social.component.scss']
})
export class SectionSocialComponent {

  @Input() public sectionSocial: SectionSocialData;


}
